// Material UI
import { Box, Typography } from "@mui/material";

// Components
import { TransferRequestHistoryTable } from "../Tables/TransferRequestHistoryTable";
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";

// Types
import { getDealerInventoryTransferHistory } from "@/DataPages/api/inventory/queries";
import { useQuery } from "@tanstack/react-query";

// Hooks
import { useFilteredData } from "../hooks/useFilteredData";

// Constants
import { InventoryTab } from "../constants";

type TransferRequestHistoryProps = {
	locationId: string;
	commissionCycleId?: string;
	payPeriodId: string;
};

export default function TransferRequestHistory(props: Readonly<TransferRequestHistoryProps>) {
	const { locationId, commissionCycleId, payPeriodId } = props;

	const { data: historyRequest, isLoading } = useQuery({
		queryKey: ["inventory", "historyRequest", locationId, commissionCycleId, payPeriodId],
		queryFn: () => getDealerInventoryTransferHistory(locationId, commissionCycleId, payPeriodId),
		enabled: !!locationId && !!commissionCycleId && !!payPeriodId,
		staleTime: Infinity,
		gcTime: Infinity,
	});

	const dataTransferHistory = useFilteredData({
		data: historyRequest?.transferRequests ?? [],
		currentOrigin: InventoryTab.DEALER_TRADES,
		pathToVinNumber: "vehicle.vinNumber",
		commissionCycleId: commissionCycleId ?? "",
		payPeriodId: payPeriodId ?? "",
	});

	return (
		<>
			<Box mt={4}>
				<Typography component={"h2"} variant={"h2"}>
					Transfer History
				</Typography>
			</Box>
			{isLoading ? (
				<Box mt={4}>
					<TableLoader toolbar buttons={2} content rows={5} multiTitles={5} />
				</Box>
			) : (
				<TransferRequestHistoryTable locationId={locationId} data={dataTransferHistory} />
			)}
		</>
	);
}
